<template>
  <div class="block-wrapper">
    <div
      :class="{
        'white-container--with-padding': !noWhiteContainer,
        'white-container--with-small-padding': smallPadding,
        'white-container--with-large-padding': largePadding,
        'full-width-on-mobile': fullWidthOnMobile,
        'no-bottom-padding': noBottomPadding,
      }"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerWrapper',
  props: {
    noWhiteContainer: {
      type: Boolean,
    },
    fullWidthOnMobile: {
      type: Boolean,
    },
    noBottomPadding: {
      type: Boolean,
    },
    smallPadding: {
      type: Boolean,
    },
    largePadding: {
      type: Boolean,
    },
  },
};
</script>

<style lang="scss" scoped>
.block-wrapper {
  margin-bottom: 2rem;
  .full-width-on-mobile {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      margin-left: math.div(-$gutter-width, 2);
      margin-right: math.div(-$gutter-width, 2);
    }
  }

  .white-container--with-small-padding {
    padding: rem(32px) rem(40px);
  }

  .white-container--with-large-padding {
    padding: rem(48px) rem(40px);
  }

  .white-container--with-padding,
  .white-container--with-small-padding,
  .white-container--with-large-padding {
    @media only screen and (max-width: $--breakpoint-sm - 1) {
      padding: rem(5px) rem(16px);
    }

    padding: rem(40px);
    border-radius: 12px;
    border: 1px solid $--border-secondary;
  }

  .no-bottom-padding {
    padding-bottom: 0;
  }
}
</style>
